export default __webpack_public_path__ + "static/media/bg_konbini_hover.672619bf.svg";